import { takeEvery, put } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import { getUserFeedback, editFeedbackComment, deleteFeedbackComment, deleteFeedback as deleteFeedbackRequest, getFeedback as getFeedbackRequest } from 'data/api';
import { transformFeedbackResponse, transformFeedback } from './transformers';
import { actions } from './slice';
import * as statelessActions from './actions';
import * as selectors from './selectors';
export function* fetchFeedback(_ref) {
  let {
    payload: {
      userId,
      feedbackFilterType
    }
  } = _ref;
  const currentPage = yield* select(selectors.getCurrentPage);
  const response = yield* call(getUserFeedback, {
    userId,
    perPage: 20,
    page: currentPage + 1,
    feedbackFilterType
  });

  if ('errors' in response) {
    yield put(actions.feedbackGetFailure({
      error: response
    }));
    return;
  }

  yield put(actions.feedbackGetSuccess({
    feedbackData: transformFeedbackResponse(response)
  }));
}
export function* deleteFeedback(_ref2) {
  let {
    payload: {
      feedbackId
    }
  } = _ref2;
  const response = yield* call(deleteFeedbackRequest, {
    feedbackId
  });

  if ('errors' in response) {
    yield put(actions.feedbackDeleteFailure({
      feedbackId,
      error: response
    }));
    return;
  }

  yield put(actions.feedbackDeleteSuccess({
    feedbackId
  }));
}
export function* createComment(_ref3) {
  let {
    payload: {
      feedbackId,
      comment
    }
  } = _ref3;
  const response = yield* call(editFeedbackComment, {
    feedbackId,
    comment
  });

  if ('errors' in response) {
    yield put(actions.feedbackCommentCreateFailure({
      feedbackId,
      error: response
    }));
    return;
  }

  yield put(actions.feedbackCommentCreateSuccess({
    feedbackId,
    feedback: transformFeedback(response.feedback)
  }));
}
export function* editComment(_ref4) {
  let {
    payload: {
      feedbackId,
      comment
    }
  } = _ref4;
  const response = yield* call(editFeedbackComment, {
    feedbackId,
    comment
  });

  if ('errors' in response) {
    yield put(actions.feedbackCommentEditFailure({
      feedbackId,
      error: response
    }));
    return;
  }

  yield put(actions.feedbackCommentEditSuccess({
    feedbackId,
    feedback: transformFeedback(response.feedback)
  }));
}
export function* deleteComment(_ref5) {
  let {
    payload: {
      feedbackId
    }
  } = _ref5;
  const response = yield* call(deleteFeedbackComment, {
    feedbackId
  });

  if ('errors' in response) {
    yield put(actions.feedbackCommentDeleteFailure({
      feedbackId,
      error: response
    }));
    return;
  }

  yield put(actions.feedbackCommentDeleteSuccess({
    feedbackId,
    feedback: transformFeedback(response.feedback)
  }));
}
export function* initiateTranslation(_ref6) {
  let {
    payload: {
      feedbackId,
      localize
    }
  } = _ref6;

  if (!localize) {
    yield put(actions.feedbackToggleTranslated({
      feedbackId,
      localize
    }));
    return;
  }

  const translatedFeedback = yield* select(selectors.getFeedbackByTranslatedId, feedbackId);

  if (translatedFeedback) {
    yield put(actions.feedbackToggleTranslated({
      feedbackId,
      localize
    }));
    return;
  }

  yield put(actions.feedbackTranslateRequest({
    feedbackId,
    localize
  }));
}
export function* translateFeedback(_ref7) {
  let {
    payload: {
      feedbackId,
      localize
    }
  } = _ref7;
  const response = yield* call(getFeedbackRequest, {
    feedbackId,
    localize
  });

  if ('errors' in response) {
    yield put(actions.feedbackTranslateFailure({
      feedbackId,
      error: response
    }));
    return;
  }

  yield put(actions.feedbackTranslateSuccess({
    feedbackId,
    feedback: transformFeedback(response.user_feedback),
    localize
  }));
}
export default function* saga() {
  yield takeEvery(actions.feedbackGetRequest, fetchFeedback);
  yield takeEvery(actions.feedbackDeleteRequest, deleteFeedback);
  yield takeEvery(actions.feedbackCommentCreateRequest, createComment);
  yield takeEvery(actions.feedbackCommentEditRequest, editComment);
  yield takeEvery(actions.feedbackCommentDeleteRequest, deleteComment);
  yield takeEvery(actions.feedbackTranslateRequest, translateFeedback);
  yield takeEvery(statelessActions.feedbackInitiateTranslation, initiateTranslation);
}